import router from '../router'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import {getToken} from './auth' // 验权
import {checkLogin} from 'api/common'
// sso路由守卫
// router.beforeEach((to, from, next) => {
//   NProgress.start(); // 开启Progress
//   if (to.path === '/login') {
//     if (getToken('sessionId')) {
//       next({path: '/home'})
//       NProgress.done()
//     } else {
//       checkLogin().then(function (res) {
//         if(res.title === '没有登录2') {
//           next();
//           NProgress.done();
//         } else {
//           localStorage.setItem('sessionId', res.data.sessionId);
//           localStorage.setItem('username', res.data.userName);
//           localStorage.setItem('userAccount', res.data.userAccount);
//           next('/home');
//           NProgress.done();
//         }
//       });
//     }
//   } else {
//     if (getToken('sessionId')) {
//       next();
//     } else {
//       checkLogin().then(function (res) {
//         if(res.title === '没有登录2') {
//           next({path: '/login'});
//           NProgress.done();
//         } else {
//           localStorage.setItem('sessionId', res.data.sessionId);
//           localStorage.setItem('username', res.data.userName);
//           localStorage.setItem('userAccount', res.data.userAccount);
//           next();
//           NProgress.done();
//         }
//       });
//     }
//   }
// });

// 正常路由守卫
router.beforeEach((to, from, next) => {
  NProgress.start(); // 开启Progress
  if (to.path === '/login' || to.path === '/') {
    if (getToken('sessionId')) {
      next({path: '/home'});
      NProgress.done()
    } else {
      next();
    }
  } else {
    if (getToken('sessionId')) {
      next();
    } else {
      next({path: '/login'});
      NProgress.done()
    }
  }
});

router.afterEach(() => {
  NProgress.done()
});



// WEBPACK FOOTER //
// ./src/utils/permission.js